import NotificationHeader from './NotificationHeader';

export default NotificationHeader;
